var e={name:"gate-notification-reader",props:{id:{type:[Number,String],required:!0},area:{type:String,default:""},type:{type:String,required:!0}}};export{e as default};
